// Contract route paths (UNIVAPLAT-3499). Leaf module: no imports, so pages, the sidebar and
// the route table can all depend on it without a cycle.
export const CONTRACTS_LIST_ROUTE = 'cdss/admin/contracts';
export const CONTRACT_NEW_ROUTE = 'cdss/admin/contracts/new';
export const CONTRACT_DETAIL_ROUTE = 'cdss/admin/contracts/:id';
export const contractDetailRoute = (id: number | string): string => `${CONTRACTS_LIST_ROUTE}/${id}`;
